import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const navigate = hooks.useNavigate()
  const { list_id } = hooks.useParams()
  const [cancelList] = hooks.useModelFunction('list', 'cancel')

  const onConfirmCancel = useCallback(async () => {
    await cancelList({ list_id })
    navigate(-1)
  }, [cancelList, list_id, navigate])

  const mergedProps = {
    onConfirmCancel
  }

  return <Component {...mergedProps} />
}

export default withContainer
